import { ApiClient, HttpMethod } from "./ApiClient";
import { AppFwConfiguration } from "../AppFwContext.ts";

export type { AppFwError } from "./ApiClient";
export { handleError } from "./ApiClient";

export interface NotificationsConfigResponse {
    readonly enabled: boolean;
}

export interface User {
    readonly id: string
    readonly name?: string
    readonly oidcName?: string
    readonly email?: string
    readonly avatarUrl?: string
}

export interface Credentials {
    readonly sessionId: string;
    readonly user: User;
}


export class AppFwApiClient extends ApiClient {

    constructor(readonly appFwConfiguration: AppFwConfiguration) {
        super(process.env.NODE_ENV === 'production' ? 'https://api.eventer.app/' : 'http://localhost:8888/')
    }

    startOidcLoginUrl(provider: string): string {
        return `${this.baseUrl}v1/appfw/auth/oidc/${this.appFwConfiguration.appName}/${provider}/start`
    }

    async sessionAuth(
        params: { sessionId: string; },
    ): Promise<Credentials> {
        return this.fetch<Credentials>(`v1/appfw/auth/session/${this.appFwConfiguration.appName}`, {
            params: { sessionId: params.sessionId }
        })
    }

    async logout(params: { sessionId: string; }) {
        return this.fetch<undefined>('v1/appfw/auth/logout', { sessionId: params.sessionId })
    }

    async getNotificationsConfig(): Promise<NotificationsConfigResponse> {
        let sessionId = localStorage.getItem('sessionId')
        return this.fetch<NotificationsConfigResponse>(
            `v1/appfw/notifications/config`,
            {
                sessionId: sessionId,
                method: HttpMethod.GET,
            },
        )
    }

    async updateNotificationsConfig(params: { enabled: boolean }) {
        let sessionId = localStorage.getItem('sessionId')
        return this.fetch<undefined>(
            `v1/appfw/notifications/config`,
            {
                sessionId: sessionId,
                method: HttpMethod.PATCH,
                params: params,
            },
        )
    }

    async updateWebPushSubscription(params: {
        installationId: string;
        subscription: PushSubscription | null;
    }) {
        let payload: undefined | PushSubscriptionJSON
        if (params.subscription) {
            payload = params.subscription.toJSON()
        }
        return this.put<undefined>(
            `v1/appfw/notifications/webpush/${params.installationId}`,
            payload
        )
    }

    async updateUserName(params: { userId: string, name: string }) {
        return this.put<undefined>(
            `v1/appfw/${this.appFwConfiguration.appName}/users/${params.userId}/name`,
            { value: params.name }
        )
    }

    async resetUserName(params: { userId: string }) {
        return this.delete<undefined>(
            `v1/appfw/${this.appFwConfiguration.appName}/users/${params.userId}/name`
        )
    }

    async getUser(params: { id: string; }): Promise<User> {
        return this.get<User>(`v1/appfw/${this.appFwConfiguration.appName}/users/${params.id}`)
    }
}